import CloseIcon from '@mui/icons-material/Close';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { FIDES_CHAT_PANEL_LAYOUT } from './fidesChatPanelLayout';
import { getPanelInitials } from './fidesChatPanelUtils';

interface FidesChatMinimizedPillProps {
  contactName: string;
  onRestore: () => void;
  onClose: () => void;
}

const FidesChatMinimizedPill: React.FC<FidesChatMinimizedPillProps> = ({
  contactName,
  onRestore,
  onClose,
}) => (
  <Box
    onClick={onRestore}
    sx={{
      position: 'fixed',
      bottom: 24,
      right: 24,
      zIndex: FIDES_CHAT_PANEL_LAYOUT.zIndex,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 1,
      backgroundColor: Palette.default.buttonBg,
      color: '#fff',
      borderRadius: 8,
      boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
      cursor: 'pointer',
      userSelect: 'none',
      maxWidth: 320,
      minWidth: 200,
    }}
  >
    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.18)', width: 32, height: 32, fontSize: 13 }}>
      {getPanelInitials(contactName)}
    </Avatar>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="body2" fontWeight={600} noWrap>
        {contactName}
      </Typography>
    </Box>
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
      sx={{ color: '#fff', p: 0.5 }}
      aria-label="Close chat panel"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </Box>
);

export default FidesChatMinimizedPill;
